export const WEEKDAYS = [
  { name: 'monday', value: 0 },
  { name: 'tuesday', value: 1 },
  { name: 'wednesday', value: 2 },
  { name: 'thursday', value: 3 },
  { name: 'friday', value: 4 },
  { name: 'saturday', value: 5 },
  { name: 'sunday', value: 6 },
]
